import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ALLOX_ROLE_KEY, AccessPermission, UrlPath } from '../constants/allox-constant';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class DirectAccessGuard  {
  constructor(
    private router: Router,

  ) { }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const helper = new JwtHelperService();
    const contents = state.url.split('/')[1];
    const alloxRole  = helper.decodeToken(localStorage.getItem(ALLOX_ROLE_KEY));
    if (alloxRole == null) {
      return this.router.parseUrl('/auth/login');
    }

    if (state.url.indexOf(UrlPath.NEW) !== -1 || state.url.indexOf(UrlPath.COPY) !== -1 ) {
      // 新規作成、コピーの際はコンテンツのCREATE権限を持っているか確認
      if (!alloxRole.permission_groups.some(p => p.contents.startsWith(contents) && p.access_permission === AccessPermission.CREATE)){
        return this.router.parseUrl(alloxRole.initial_contents);
      }
    } else if (state.url.indexOf(UrlPath.EDIT) !== -1){
      // 編集の際はコンテンツのUPDATE権限を持っているか確認
      if (!alloxRole.permission_groups.some(p => p.contents.startsWith(contents) && p.access_permission === AccessPermission.UPDATE)){
        return this.router.parseUrl(alloxRole.initial_contents);
      }
    } else {
      if (!alloxRole.permission_groups.some(p => p.contents.startsWith(contents))){
        return this.router.parseUrl(alloxRole.initial_contents);
      }
    }
    return true;
  }
}
